import { useEffect, useState } from 'react'
import MarkdownEditor from '@uiw/react-markdown-editor'
import '@uiw/react-markdown-editor/markdown-editor.css'
import '@uiw/react-markdown-preview/markdown.css'
import 'github-markdown-css/github-markdown.css'
import useDeviceDetect from '../../hooks/useDeviceDetect'
import useLocalStorage from '../../hooks/useLocalStorage'
import "./markdown-editor.css"

export const EditorColumn = ({
  focusedSectionSlug,
  templates,
  setTemplates,
  language, // e.g., "en", "hi", "ur", "te"
}) => {
  const { isMobile } = useDeviceDetect()
  const { saveBackup } = useLocalStorage()

  const getMarkdown = () => {
    const section = templates.find((s) => s.slug === focusedSectionSlug)
    return section ? section.markdown : ''
  }

  const [markdownContent, setMarkdownContent] = useState(getMarkdown())

  // Determine direction based on language
  const isRTL = language === 'ur' // Only Urdu is RTL among common options

  useEffect(() => {
    const content = getMarkdown()
    setMarkdownContent(content)
    // eslint-disable-next-line
  }, [focusedSectionSlug])

  const onChange = (value = '') => {
    setMarkdownContent(value)

    const updatedTemplates = templates.map((t) =>
      t.slug === focusedSectionSlug
        ? { ...t, markdown: value }
        : t
    )

    setTemplates(updatedTemplates)
    saveBackup(updatedTemplates)
  }

  // Dynamic styles based on language direction
  const editorStyles = {
    direction: isRTL ? 'rtl' : 'ltr',
    textAlign: isRTL ? 'right' : 'left',
    unicodeBidi: 'plaintext', // Best for mixed LTR/RTL content
  }

  const placeholderText = {
    en: "Start writing here...",
    hi: "यहाँ लिखना शुरू करें...",
    ur: "یہاں لکھنا شروع کریں...",
    te: "ఇక్కడ రాయడం ప్రారంభించండి...",
  }[language] || "Start writing here..."

  return (
    <div className="flex-1 md:w-[33vw] max-w-full border border-gray-300 rounded bg-white">
      {isMobile ? (
        <textarea
          className="w-full h-full p-6 resize-none outline-none overflow-y-auto whitespace-pre-wrap break-words font-sans text-base"
          value={markdownContent}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholderText}
          style={editorStyles}
          dir={isRTL ? "rtl" : "ltr"}
          lang={language}
        />
      ) : (
        <div className="h-full w-full overflow-y-auto" style={editorStyles}>
          <MarkdownEditor
            value={markdownContent || "Select a section to start editing"}
            onChange={onChange}
            preview="edit"
            enablePreview={false}
            visible={true}
            width="100%"
            height="72vh"
            options={{
              direction: isRTL ? 'rtl' : 'ltr',
              unicodeBidi: 'plaintext',
            }}
            style={{
              ...editorStyles,
              fontFamily: 'inherit',
              backgroundColor: '#fff',
            }}
            className={`wmde-markdown-editor-dynamic ${isRTL ? 'wmde-markdown-editor-rtl' : 'wmde-markdown-editor-ltr'} break-all`}
          />
        </div>
      )}
    </div>
  )
}